export type EpochAction = 'start'

export const EPOCH_ACTION_LABELS: Record<EpochAction, string> = {
  start: 'Start Epoch',
}

export const EPOCH_ACTION_DESCRIPTIONS: Record<EpochAction, string> = {
  start: 'Start a new epoch with TSS info',
}
